export default __webpack_public_path__ + "static/media/avatars@2x.98dfe024.png";